<template>
  <v-card class="default-card">
    <v-card-text>
      <v-row>
        <v-col>
          <ClientComponentsSelector />
        </v-col>
      </v-row>
      <v-divider class="section-divider"></v-divider>
      <v-row class="prefab-detail-row">
        <v-col cols="4">
          <PrefabWallViewer />
        </v-col>
        <v-col>
          <PrefabWallDetailTab v-model:tab="tab" :scheduleTable="scheduleTable" />
        </v-col>
      </v-row>
      <v-divider class="section-divider"></v-divider>
      <PanelMaxSizeInputs v-model:width="width" v-model:length="length" />
    </v-card-text>
    <v-card-actions class="card-actions">
      <v-btn color="secondary" variant="flat" @click="goToDashboardView">
        {{ $t('buttons.backToDashboard') }}
      </v-btn>
      <v-divider class="section-divider"></v-divider>
      <v-btn color="secondary" variant="flat" @click="goToDashboardViewAndSave">
        {{ $t('buttons.backToDashboardAndSave') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script setup>
import ClientComponentsSelector from "@/components/architect/ClientComponentsSelector.vue";
import { ref, computed } from 'vue';
import { useStore } from "vuex";
import PrefabWallViewer from "@/components/viewer/PrefabWallViewer.vue";
import PrefabWallDetailTab from "@/components/architect/panelCountEstimator/PrefabWallDetailTab.vue";
import PanelMaxSizeInputs from "@/components/architect/panelCountEstimator/PanelMaxSizeInputs.vue";
import { useProjectSave } from "@/composables/useProjectSave";


const store = useStore();

const { runPanelizationAndSave, initializeCarbonImpact, navigateToDashboard } = useProjectSave();

const tab = ref('Composition');

const length = ref(store.state.projectData?.panelCountEstimator?.panelConfiguration?.maxPanelLength ?? 110);
const width = ref(store.state.projectData?.panelCountEstimator?.panelConfiguration?.maxPanelWidth ?? 288);

const scheduleTable = computed(() => {
  return store.state.scheduleTable;
});

// walls kept reactive so panelization always uses the latest user selection
const selectedWalls = computed(() => store.state.customer.selectedWallType);
const prefabricatedWallType = computed(() => store.state.scheduleTable.selectedWallType);

async function goToDashboardViewAndSave() {
  await runPanelizationAndSave(selectedWalls, {
    maxPanelLength: length,
    maxPanelWidth: width,
    prefabricatedWallType,
  });
  await initializeCarbonImpact();
  navigateToDashboard();
}

async function goToDashboardView() {
  navigateToDashboard();
}

</script>

<style scoped>
@import '@/assets/styles/views/Architect/PanelCountEstimator/PanelCountEstimatorView.css';
@import '@/assets/styles/views/HomeView.css';
</style>
